import React, { useRef, useState } from 'react';
import { Input } from "antd";
import "./index.scss";
import { useOutsideComponent } from "../../../hooks/useOutsideComponent";

const AppInputSelect = ({ value, onChange, options = [], labelKey = 'label', valueKey = 'value' }) => {
  const [focused, setFocused] = useState(false);

  const inputSelectRef = useRef(null);

  const onSelect = (value) => {
    onChange(value);
    setFocused(false);
  };

  useOutsideComponent(inputSelectRef, () => setFocused(false));

  return (
    <div ref={inputSelectRef} className="app-input-select">
      <div className="control">
        <Input
          value={value}
          onChange={(event) => {
            const value = event.target.value;
            onChange(value);
          }}
          allowClear
          onFocus={() => setFocused(true)}
        />
      </div>
      {
        focused && !!options?.length && (
          <div className="dropdown">
            {
              options.map((option, index) => (
                <div
                  title={option[valueKey]}
                  key={index}
                  className={`option ${value === option[valueKey] ? 'selected' : ''}`}
                  onClick={() => onSelect(option[valueKey])}
                >
                  {option[labelKey]}
                </div>
              ))
            }
          </div>
        )
      }
    </div>
  )
}
export default AppInputSelect;